import React from "react";

export default function VerifyEmail() {
  return (
    <div className="text-green-400 p-6">
      <h1 className="text-3xl font-bold">Verify your email</h1>
      <p className="mt-3 max-w-xl">
        A verification link has been sent to your email. Please verify before logging in.
      </p>
    </div>
  );
}
